import { AssistentItem } from './assistent_config';
import { DataService } from '../../../services/data_service';
import { getAssistentConfigKonfig } from './items/assistent_config_config';
import { getAssistentConfigWaerme } from './items/assistent_config_waerme';
import { getAssistentConfigKraftstoffe } from './items/assistent_config_kraftstoffe';
import { getAssistentConfigStandorte } from './items/assistent_config_standorte';
import { getAssistentConfigCO2 } from './items/assistent_config_co2';
import { getAssistentConfigStrom, getAssistentConfigEigenStrom } from './items/assistent_config_strom';
import { getAssistentConfigUnternehmen } from './items/assistent_config_unternehmensdaten';
import { getAssistentConfigVsmeBasisItems } from './items/assistent_config_vsme_basis';
import { getAssistentConfigVsmeBpmItems } from './items/assistent_config_vsme_bpm';
import { getAssistentConfigVsmePatItems } from './items/assistent_config_vsme_pat';
import { IDs } from '../../../helpers/IDs';
import { isEnableErneuerbareEnergien, isEnableStandorte } from './assistent_helpers';
import { StructureService } from '../../../services/structure_service';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { getAssistentConfigVsmeBasisItemsOld } from './items/assistent_config_vsme_basis_old';

export function getAssistentConfigVsmeOld(
    standort: any, data: any, jahr: number, dataService: DataService, triggerService: TriggerService, structureService: StructureService,
    onRoutingChange: (routing: any) => void, clearPruefState: () => void, isAdmin: boolean, bereichKey: string, routing: any
) {
    standort = standort || {};
    const b1: any = ((data || {})[IDs.ENT_VSME_B1] || [])
        .find((item: any) => (item.standort_tid_orig || item.standort_tid) === standort.tid) || {};
    const b3: any = ((data || {})[IDs.ENT_VSME_B3] || [])
        .find((item: any) => (item.standort_tid_orig || item.standort_tid) === standort.tid) || {};
    const config: AssistentItem[] = [];
    const konfiguration: any[] = data[IDs.ENT_KONFIGURATION] || [];
    const includePatModul = Object.keys(b1).length ? (b1.modul === 'basis_pat' || b1.modul === 'basis_pat_geschaeft') : true;
    const includeBpmModul = Object.keys(b1).length ? (b1.modul === 'basis_geschaeft' || b1.modul === 'basis_pat_geschaeft') : true;
    const useB3Group: boolean = b3.e_tool_nutzung_orig !== 2; // {1} Ja, {2} Nein
    const isKonsolidiert: boolean = b1.bericht === 'konsolidiert';
    const vsmeStructures = [
        ...getAssistentConfigVsmeBasisItemsOld(data, triggerService, structureService),
        ...(includePatModul ? getAssistentConfigVsmePatItems(standort, data, jahr, triggerService, structureService) : []),
        ...(includeBpmModul ? getAssistentConfigVsmeBpmItems(standort, data, jahr, triggerService, structureService) : []),
    ];
    (vsmeStructures || []).forEach((struc: any) => {
        if (struc.entity && struc.group !== 'vsme_basis') {
            if (checkVSMEAuswahl(data, standort.tid, jahr, struc)) {
                config.push(struc);
            }
        } else {
            config.push(struc);
            if (struc.entity === IDs.ENT_VSME_B1) {
                // config.push(getAssistentConfigKonfig(data, onRoutingChange, isAdmin, bereichKey, { gliederung: '2.1.1', gliederung2: 'B1.1:', name: 'Berater', group: 'vsme_basis_b1', colBg: '#eee', configFlag: 'vsmeBerater', disablePruefer: false }));
                config.push(getAssistentConfigUnternehmen(data, triggerService, { gliederung: '2.1.1', gliederung2: 'B1.1:', group: 'vsme_basis_b1', colBg: '#eee', configFlag: 'vsmeUnternehmen', disablePruefer: false }));
                if (isEnableStandorte(konfiguration) || isKonsolidiert) {
                    config.push(getAssistentConfigStandorte(data, dataService, triggerService, { gliederung: '2.1.2', gliederung2: 'B1.2:', group: 'vsme_basis_b1', colBg: '#eee', configFlag: 'vsmeStandorte', disablePruefer: false }));
                }
            }
            if (struc.entity === IDs.ENT_VSME_B3 && useB3Group) {
                config.push(getAssistentConfigStrom(standort, data, jahr, triggerService, { gliederung: '2.3.1', gliederung2: 'B3.1:', group: 'vsme_basis_b3', colBg: '#eee' }));
                if (isEnableErneuerbareEnergien(konfiguration)) {
                    config.push(getAssistentConfigEigenStrom(standort, data, { gliederung: '2.3.2', gliederung2: 'B3.2:', group: 'vsme_basis_b3', colBg: '#eee' }));
                }
                config.push(getAssistentConfigWaerme(standort, data, jahr, triggerService, { gliederung: '2.3.3', gliederung2: 'B3.3:', group: 'vsme_basis_b3', colBg: '#eee' }));
                config.push(getAssistentConfigKraftstoffe(standort, data, jahr, triggerService, { gliederung: '2.3.4', gliederung2: 'B3.4:', group: 'vsme_basis_b3', colBg: '#eee' }));
                config.push(getAssistentConfigCO2({ gliederung: '2.3.5', gliederung2: 'B3.5:', group: 'vsme_basis_b3', colBg: '#eee' }));
            }
        }
    });

    return config;
}

function checkVSMEAuswahl(data: any, standortTid: number, jahr: number, struc: any) {
    const fnd = (data[IDs.ENT_VSME_AUSWAHL] || [])
        .find((r: any) => r.standort_tid_orig === standortTid && r.jahr === jahr && r.name === struc.entity && r.category === struc.group);
    if (fnd && fnd.auswahl === 1) {
        return true;
    }
    return false;
}

export function getVSMEAuswahl(data: any, standortTid: number, jahr?: number, jahrVon?: number, jahrBis?: number, group?: string) {
    const auswahl = (data[IDs.ENT_VSME_AUSWAHL] || [])
        .filter((r: any) =>
            r.standort_tid_orig === standortTid
            && (jahr > 0 ? r.jahr === jahr : true)
            && (jahrVon > 0 && jahrBis > 0 ? r.jahr >= jahrVon && r.jahr <= jahrBis : true)
            && (group ? r.category === group : true)
            && r.auswahl === 1
        )
        .map((r: any) => r.name)
        .filter((key: string, idx: number, self: string[]) => self.indexOf(key) === idx)
        .sort();
    return auswahl;
}

